import React, { useState } from "react";
import useReduxData from "../../hooks/useReduxData";
import useChangeStore from "../../hooks/useChangeStore";
import GlobalButton from "../Buttons/btn2/GlobalButton";
import { ReturnStoreAddress } from "../../utils/helper";

const ChangeStoreComponent = () => {
  const { changeStore } = useChangeStore();
  const {
    store: { allStore },
  } = useReduxData();

  const [selectedStore, setSelectedStore] = useState<any>(null);

  const handleStoreSelect = (id: any) => {
    setSelectedStore(id);
  };

  const handleProceed = () => {
    changeStore(selectedStore);
  };

  return (
    <div className="h-[calc(100vh-4rem)] flex flex-col items-center justify-start p-6 relative bg-gray-50 md:top-[2.5rem] top-[3.75rem]">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-md p-6 mt-6">
        <h1 className="text-xl font-semibold text-gray-800 mb-4">
          Choose a Store
        </h1>

        <div className="flex flex-col gap-2">
          {allStore?.map((store: any) => {
            const store_data = store.store_data;
            const store_id = store_data?.store_id;

            let img_url = "";
            if (store_data?.store_image?.attachment_url) {
              img_url =
                store_data?.store_image?.base_url +
                store_data?.store_image?.attachment_url;
            } else {
              img_url =
                store_data?.banner_image?.base_url +
                store_data?.banner_image?.attachment_url;
            }

            const isSelected = selectedStore === store_id;

            return (
              <div
                key={store_id}
                onClick={() => handleStoreSelect(store_id)}
                className={`flex items-center justify-between p-3 rounded-xl cursor-pointer transition border ${
                  isSelected
                    ? "border-[#34558b] bg-[#f3f6ff]"
                    : "border-gray-200 hover:bg-gray-50"
                }`}
              >
                {/* Left section (Logo + Name) */}
                <div className="flex items-center gap-3">
                  <img
                    src={img_url}
                    alt={store_data?.store_name}
                    className="w-10 h-10 rounded-lg object-cover border border-gray-200"
                  />
                  <div className="flex flex-col">
                    <h2 className="text-sm font-semibold text-gray-800">
                      {store_data?.store_name}
                    </h2>
                    <p className="text-xs text-gray-500  line-clamp-2">
                      {ReturnStoreAddress(store_data)}
                    </p>
                  </div>
                </div>

                {/* Right section (Selected indicator) */}
                {/* {isSelected ? (
                  <div className="w-5 h-5 rounded-full bg-[#34558b] flex items-center justify-center" />
                ) : (
                  <div className="w-5 h-5 rounded-full border border-gray-300" />
                )} */}
              </div>
            );
          })}

          {/* Add New Store (Optional) */}
          {selectedStore && 
          <div className="flex items-center gap-3 p-3 mt-2  cursor-pointer">
            {/* <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center text-gray-400 text-xl">
              +
            </div>
            <span className="text-sm font-medium text-gray-700">
              Add a new store
            </span> */}
             <GlobalButton
              label="Proceed with the selected store"
              onClick={handleProceed}
              loading={false}
            />
          </div>
}
       </div>
      </div>

     
    </div>
  );
};

export default ChangeStoreComponent;
